import certificate1 from "../assets/thumbnail/thumb_fsc.jpg";
import certificate2 from "../assets/thumbnail/thumb_ifcc.jpg";
import certificate3 from "../assets/thumbnail/thumb_iso9001.jpg";
import certificate4 from "../assets/thumbnail/thumb_iso45001.jpg";
import certificate5 from "../assets/thumbnail/thumb_warringtonfire_glazed_door.jpg";
import certificate6 from "../assets/thumbnail/thumb_warringtonfire_unglazed_door.jpg";
import certificate7 from "../assets/thumbnail/thumb_svlk.jpg";
import certificate8 from "../assets/thumbnail/thumb_hasil_uji_flat_door.jpg";
import certificate9 from "../assets/thumbnail/thumb_hasil_uji_panel_door.jpg";
import certificate10 from "../assets/thumbnail/thumb_tkdn_eng_door.jpg";
import certificate11 from "../assets/thumbnail/thumb_tkdn_solid_door.jpg";

import pdfCertificate1 from "../assets/certificate/FSC.pdf";
import pdfCertificate2 from "../assets/certificate/IFCC.pdf";
import pdfCertificate3 from "../assets/certificate/ISO_9001.pdf";
import pdfCertificate4 from "../assets/certificate/ISO_45001.pdf";
import pdfCertificate5 from "../assets/certificate/Warringtonfire_Glazed_Door.pdf";
import pdfCertificate6 from "../assets/certificate/Warringtonfire_Unglazed_Door.pdf";
import pdfCertificate7 from "../assets/certificate/SVLK.pdf";
import pdfCertificate8 from "../assets/certificate/Hasil_Uji_Flat_Door.pdf";
import pdfCertificate9 from "../assets/certificate/Hasil_Uji_Panel_Door.pdf";
import pdfCertificate10 from "../assets/certificate/TKDN_Pintu_Engineering.pdf";
import pdfCertificate11 from "../assets/certificate/TKDN_Pintu_Solid.pdf";

export const certificateList = [
  {
    id: "1",
    title: "Certificate FSC",
    image: certificate1,
    pdf: pdfCertificate1,
    valid: "This certificate is valid from 22 January 2023 until 21 January 2028",
  },
  {
    id: "2",
    title: "Certificate IFCC",
    image: certificate2,
    pdf: pdfCertificate2,
    valid: "This certificate is valid from 27 May 2024 until 26 May 2029",
  },
  {
    id: "3",
    title: "Certificate ISO 9001",
    image: certificate3,
    pdf: pdfCertificate3,
    valid: "This certificate is valid from 01 March 2024 until 28 February 2027",
  },
  {
    id: "4",
    title: "Certificate ISO 450001",
    image: certificate4,
    pdf: pdfCertificate4,
    valid: "This certificate is valid from 02 February 2023 until 01 February 2026",
  },
  {
    id: "5",
    title: "Certificate Warringtonfire Glazed Door",
    image: certificate5,
    pdf: pdfCertificate5,
    valid: "This certificate is valid from 26 June 2023 until 26 June 2028",
  },
  {
    id: "6",
    title: "Certificate Warringtonfire Un-Glazed Door",
    image: certificate6,
    pdf: pdfCertificate6,
    valid: "This certificate is valid from 13 November 2019 until 13 November 2024",
  },
  {
    id: "7",
    title: "Certificate SVLK",
    image: certificate7,
    pdf: pdfCertificate7,
    valid: "This certificate is valid from 13 January 2021 until 12 January 2027",
  },
  {
    id: "8",
    title: "Laporan Hasil Uji Flat - Fire Door",
    image: certificate8,
    pdf: pdfCertificate8,
    valid: "Tanggal Uji 5 April 2023",
  },
  {
    id: "9",
    title: "Laporan Hasil Uji Panel - Fire Door",
    image: certificate9,
    pdf: pdfCertificate9,
    valid: "Tanggal Uji 5 April 2023",
  },
  {
    id: "10",
    title: "TKDN Pintu Engineering",
    image: certificate10,
    pdf: pdfCertificate10,
    valid: "",
  },
  {
    id: "11",
    title: "TKDN Pintu Solid",
    image: certificate11,
    pdf: pdfCertificate11,
    valid: "",
  },
];
